import React from 'react'

const AttendancePage = () => {
  return (
    <div>
      <h1>Attendance Page</h1>
    </div>
  )
}

export default AttendancePage
